var toObject = require('../internals/to-object');

var hasOwnProperty = {}.hasOwnProperty;

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty.call(toObject(it), key);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/has-own-property.js
// module id = 43
// module chunks = 1